import { createAction, props } from '@ngrx/store';
import {
  EffectiveRole,
  InviteAdmin,
  PaginatedRequest,
  PaginatedResponse,
  RemoveUserRequest,
  TenantHierarchyUsersRequest,
  TenantUser,
  TenantUtilityTokens,
  TransferOwnership,
} from '../common-admin.model';

export const refreshTenantGrid = createAction('[TENANT] Refresh Tenant Grid');
export const clearTenantGridRefresh = createAction('[TENANT] Clear Tenant Grid Refresh');

export const setTenantId = createAction('[TENANT] Set Tenant Id', props<{ tenantId: string }>());

export const getTenantUtilityTokens = createAction(
  '[TENANT UTILITY TOKENS] Get Current Tenant Utility Tokens and Entitlements',
  props<{ value: string }>(),
);

export const setTenantUtilityTokens = createAction(
  '[TENANT UTILITY TOKENS] Set Current Tenant Utility Tokens',
  props<{ payload: TenantUtilityTokens }>(),
);

export const getTenantUsers = createAction(
  '[TENANT] Get all users of a Tenant',
  props<{ payload: PaginatedRequest }>(),
);

export const setTenantUsers = createAction(
  '[TENANT] Set all users of a Tenant',
  props<{ tenantUsers: TenantUser[] }>(),
);

export const getTenantHierarchyUsers = createAction(
  '[TENANT] Get Tenant Hierarchy Users',
  props<{ payload: TenantHierarchyUsersRequest }>(),
);

export const setTenantHierarchyUsers = createAction(
  '[TENANT] Set Tenant Hierarchy Users',
  props<{ selectedTenantUsers: PaginatedResponse<TenantUser> }>(),
);

export const transferOwnership = createAction(
  '[TENANT] Initiate Transfer Ownership',
  props<{ payload: TransferOwnership }>(),
);

export const createAdminInvitation = createAction('[INVITATION] Create Invitations', props<{ payload: InviteAdmin }>());

export const getTenantDetails = createAction('[TENANT] Get Tenant Details', props<{ value: string }>());

export const setTenantDetails = createAction('[TENANT] Set Tenant Details', props<{ payload: any }>());

export const removeUserFromTenant = createAction(
  '[TENANT] Remove User From Tenant',
  props<{ payload: RemoveUserRequest }>(),
);

export const unarchiveTenant = createAction(
  '[TENANT] Unarchive Tenant Status',
  props<{ tenantId: string; orgName: string; archive: boolean }>(),
);

export const archiveTenant = createAction(
  '[TENANT] Archive Tenant Status',
  props<{ tenantId: string; archive: boolean }>(),
);

export const getTenantEffectiveRoles = createAction(
  '[TENANT] Get Tenant Effective Roles',
  props<{ tenantId: string; userId: string }>(),
);

export const setTenantEffectiveRoles = createAction(
  '[TENANT] Set Tenant Effective Roles',
  props<{ tenantEffectiveRoles: EffectiveRole[] }>(),
);

export const resetTenantEffectiveRoles = createAction('[TENANT] Reset Tenant Effective Roles');
